<script>
import Service from '../../services/movement-instruction';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column'; 
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';

export default{
    props: ['item', 'idMovementInstructionHeader'],
    components: {
        Dialog, DataTable, Column, 
        InputText, Button, Calendar
    },
    data(){
        return {
            visible: false,
            loading: false,
            data: [],
            params: {
                // start: 0,
                // limit: 25
            },
            editingData: null,
            editingDataVisible: false
        }
        
    },
    mounted(){
        
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        show(){
            this.visible = true;
        },
        loadData(){
            let filters = [];
            filters.push({
                operator: 'eq',
                value: this.idMovementInstructionHeader,
                property: 'IdMovementInstructionHeader'
            });

            this.params.filter = JSON.stringify(filters);
            Service.getEta(this.params, response => {
                if(response.success){
                    this.data = response.data;
                    this.total = response.totalCount;
                }
            });
        },
        addRecord(){
            this.editingDataVisible = true;
            this.editingData = {
                id: null,
                idMovementInstructionHeader: this.idMovementInstructionHeader,
                etaNumber: 0,
                eta: new Date(),
                notifyDate: new Date(),
                notifyMeans: "",
                isDeleted: false
            };
        },
        editEta(data){
            data.eta =  Utils.dateToCurrentTimeZone(data.eta);
            data.notifyDate =  Utils.dateToCurrentTimeZone(data.notifyDate);
            this.editingData = {...data};
            this.editingDataVisible = true;
        },
        saveEta(){
            if(this.editingData.id == null){
                Service.createEta(this.editingData, response => {
                    if(response.success){
                        this.editingDataVisible = false;
                        this.editingData = null;
                        this.loadData();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }else{
                Service.updateEta(this.editingData, response => {
                    if(response.success){
                        this.editingDataVisible = false;
                        this.editingData = null;
                        this.loadData();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        }
    }
  }
</script>


<template>
    <main>
        <Dialog :header="$t('movementInstructions.eta')" v-model:visible="visible" :style="{width: '75vw'}" :modal="true">
            <Button :label="$t('btn.add')" icon="pi pi-plus" class="m-4 p-button-outlined" @click="addRecord" name="movementInstructionsEtaAddButton" :disabled="!uiPermissions('movementInstructionsEtaAddButton').isEnabled" v-if="!uiPermissions('movementInstructionsEtaAddButton').isHidden"/>
            <DataTable style="height: 26vw" :loading="loading"
            :reorderableColumns="true"
                :value="data" :lazy="true" showGridlines stripedRows  ref="dt" :resizableColumns="true" columnResizeMode="expand">
                    <Column :header="$t('movementInstructions.etaNumber')"
                        field="etaNumber" dataType="number">
                        <template #body="element">
                            {{element.data.etaNumber}}
                        </template>
                    </Column>
                    <Column :header="$t('movementInstructions.eta')"
                        field="eta" dataType="date">
                        <template #body="element">
                            {{element.data.eta != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.eta)) : null}}
                        </template>
                    </Column>
                    <Column :header="$t('movementInstructions.notifyDate')"
                        field="notifyDate" dataType="date">
                        <template #body="element">
                            {{element.data.notifyDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.notifyDate)) : null}}
                        </template>
                    </Column>
                    <Column :header="$t('movementInstructions.notifyMeans')"
                        field="notifyMeans" dataType="string">
                        <template #body="element">
                            {{element.data.notifyMeans}}
                        </template>
                    </Column>
                    <!-- <Column :exportable="false" > -->
                    <!-- <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-text mr-2" @click="editEta(slotProps.data)" />
                    </template> -->
                    <!-- </Column> -->
                <template #empty>
                    {{$t('noRecordsFound')}}
                </template>
            </DataTable>

            <Dialog v-model:visible="editingDataVisible" :style="{width: '450px'}" :modal="true" class="p-fluid">
                <!-- <div class="field">
                    <label for="etaNumber">{{$t('movementInstructions.etaNumber')}}</label>
                    <InputText id="etaNumber" v-model="editingData.etaNumber" required="true" autofocus type="number"/>
                </div> -->
                <div class="field">
                    <label for="eta">{{$t('movementInstructions.eta')}}</label>
                     <Calendar 
                        id="eta" 
                        :showTime="true" :showSeconds="true"
                        v-model="editingData.eta"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :dateFormat="constants.DATE_FORMAT" />
                </div>
                <div class="field">
                    <label for="notifyDate">{{$t('movementInstructions.notifyDate')}}</label>
                     <Calendar 
                        id="notifyDate" 
                        :showTime="true" :showSeconds="true"
                        v-model="editingData.notifyDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :dateFormat="constants.DATE_FORMAT" />
                </div>
                <div class="field">
                    <label for="notifyMeans">{{$t('movementInstructions.notifyMeans')}}</label>
                    <InputText id="notifyMeans" v-model="editingData.notifyMeans" required="true" autofocus type="string"/>
                </div>
                <template #footer>
                    <Button :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="editingDataVisible = false"/>
                    <Button :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="saveEta" />
                </template>
            </Dialog>

            <template #footer>
                <!-- <Button label="Select" icon="pi pi-check" @click="closeDialog" autofocus /> -->
            </template>
        </Dialog>
    </main>

</template>